module.exports = __webpack_public_path__ + "static/media/refil-bliss.8bf1d83b.jpg";